import { Pipe, PipeTransform } from '@angular/core';

import { IEnclosure } from '../../shared/models/enclosure.model';

@Pipe({
    name: 'isEnclosureTypeSelected',
    standalone: false
})
export class IsEnclosureTypeSelectedPipe implements PipeTransform {

  transform(enclosure: IEnclosure): boolean {
    return enclosure?.productId === 0 && (enclosure?.enclosureType === null || enclosure?.enclosureType === 0);
  }

}
